module.exports = __webpack_public_path__ + "img/target.fbcf5fcb.svg";